import reservation_mutators from "../../base/reservation_mutators";
import model                from "../model";
import ReservationKiosk     from "../components/ReservationKiosk";
import steps                from "../steps";
import resources            from "./resources";

export default {
    state         : {
        component  : ReservationKiosk,
        steps,
        model      : model,
        model_local: {
            reservee_form: {
                model: null
            }
        },
        resources  : resources,
        meta: {
            reservation_variant: 'daily'
        }
    },
    mutations     : {
        ...reservation_mutators
    }

}
